import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import dynamic from 'next/dynamic';
import { OptimizelySubitoFeature } from '@sbt-web/houston-wrapper';
const Banner = dynamic(() => import('./banner'), {
  ssr: false
});
const GalleryCTA: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <OptimizelySubitoFeature feature="subito-product-marketing.listing.gallery-banner">{_temp}</OptimizelySubitoFeature>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default GalleryCTA;
function _temp(enabled, features) {
  if (enabled) {
    return <Banner title={features.title} body={features.body} imageSrc={features.image} imageAlt={features.alt} imageWidth={features.imageWidth} imageHeight={features.imageHeight} buttonText={features.buttonText} buttonURL={features.buttonURL} />;
  }
}